
    export default {
        props: ['news'],
        computed: {
            get_url: () => (title) => {
                title = title.toLowerCase().replace(/ž/g, "z").replace(/č/g, "c").replace(/đ/g, "d").replace(/š/g, "s").replace(/ć/g, "c").replace("?", ".")
                return encodeURI('/novost/' + title.toLowerCase().replace(/ /g, '_'));
                // .replace(/[^\w-]+/g, '');
            },
        },
        mounted() {},
        methods: {
            // toNews(news){
                //if (this.$route.params.news_title !== news.title){
                    // this.$router.push({ name: 'news_article', params: { news_title: news.title }, query: { timestamp: Date.now() } })
                //}
            // }
        }
    }
